import { render, staticRenderFns } from "./ExportLink.vue?vue&type=template&id=8812e6b6&scoped=true&"
import script from "./ExportLink.vue?vue&type=script&lang=js&"
export * from "./ExportLink.vue?vue&type=script&lang=js&"
import style0 from "./ExportLink.vue?vue&type=style&index=0&id=8812e6b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8812e6b6",
  null
  
)

export default component.exports